import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { api, fmtDay, money, Quote, QUOTE_STATUS_CLASS } from '../api';
import { useSession } from '../session';
import { ErrorBox, useAsync } from '../components/ui';

const FILTERS: [string, string][] = [['', 'mind'], ['draft', 'piszkozat'], ['pending_approval', 'jóváhagyásra vár'], ['approved', 'küldhető'], ['sent', 'elküldve'], ['accepted', 'elfogadva'], ['rejected', 'elutasítva']];

export function QuotesPage() {
  const s = useSession();
  const nav = useNavigate();
  const [status, setStatus] = useState(s.role === 'owner' ? '' : '');
  const [q, setQ] = useState('');
  const [data, setData] = useState<{ items: Quote[]; total: number } | null>(null);
  const [pending, setPending] = useState(0);
  const a = useAsync();
  useEffect(() => {
    const t = setTimeout(() => a.run(async () => {
      setData(await api(`/quotes?limit=200${status ? `&status=${status}` : ''}${q ? `&query=${encodeURIComponent(q)}` : ''}`));
      setPending((await api<{ total: number }>('/quotes?status=pending_approval&limit=1')).total);
    }), q ? 200 : 0);
    return () => clearTimeout(t);
  }, [status, q]);
  const create = async () => { const r = await a.run(() => api<Quote>('/quotes', { method: 'POST', body: { title: 'Új ajánlat' } })); if (r) nav(`/ajanlatok/${r.id}`); };
  return (
    <div>
      <div className="page-head">
        <h2>Ajánlatok</h2>
        <input className="search" placeholder="Keresés sorszám, megnevezés vagy cég szerint…" value={q} onChange={(e) => setQ(e.target.value)} />
        <button onClick={create}>Új ajánlat</button>
        <Link to="/termekek">Termékek és árlisták</Link>
        {s.role === 'owner' && <Link to="/ajanlatok/beallitasok">Beállítások</Link>}
      </div>
      {s.role === 'owner' && pending > 0 && status !== 'pending_approval' &&
        <div className="notice">{pending} ajánlat kedvezménye vár a jóváhagyásodra. <button className="link inline" onClick={() => setStatus('pending_approval')}>Megnézem</button></div>}
      <div className="filters">{FILTERS.map(([k, l]) => <button key={k} className={status === k ? '' : 'secondary'} onClick={() => setStatus(k)}>{l}</button>)}</div>
      <ErrorBox error={a.error} />
      <table className="list">
        <thead><tr><th>Sorszám</th><th>Megnevezés</th><th>Cég</th><th>Állapot</th><th className="num">Bruttó</th><th>Érvényes</th></tr></thead>
        <tbody>
          {data?.items.map((x) => (
            <tr key={x.id} onClick={() => nav(`/ajanlatok/${x.id}`)}>
              <td><Link to={`/ajanlatok/${x.id}`}>{x.label}</Link></td><td>{x.title}</td><td>{x.company_name ?? '–'}</td>
              <td><span className={`badge ${QUOTE_STATUS_CLASS[x.status] ?? ''}`}>{x.status_hu}</span></td>
              <td className="num">{money(x.gross_total, x.currency)}</td><td>{fmtDay(x.valid_until)}</td>
            </tr>
          ))}
          {data?.items.length === 0 && <tr><td colSpan={6} className="muted">Nincs ajánlat. A deal adatlapjáról is indíthatsz egyet.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
